// project modules
import { getBaseUrl, sendRequest } from '../helpers/apiHelper';

// models
import { loginViewModel } from "../models/types/auth";

export const loginBySMS = async (user: loginViewModel, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/auth/loginBySMS`, 'post', user, null, abortSignal);
};

//verifyUserSmsCode
export const loginUser = async (user: loginViewModel, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/auth/verifyUserSmsCode`, 'post', user, null, abortSignal);
};

export const loginUserWithPassword = async (user: loginViewModel, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/auth/login`, 'post', user, null, abortSignal);
};

export const selectDestination = async (resolverId: number, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/auth/selectDestination`, 'post', resolverId, null, abortSignal);
};

export const checkAuthStatus = async (abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/auth/check`, 'get', null, null, abortSignal);
};

// export const verifyUserSmsCode = async (user: verifyUserSmsModel, abortSignal?: AbortSignal) => {
//   return await sendRequest(`${getBaseUrl()}/auth/verifyUserSmsCode`, 'post', user, null, abortSignal);
// };

